/** 全局方法类 */
const VogUtils = {
  /** 获取当前的shopify环境 */
  getShopifyEnv() {
    // 如果url有shopifyEnv参数，则使用url的shopifyEnv参数
		// 因为调试主题时，可能通过localhost或者127.0.0.1访问，此时无法通过url判断环境
		let shopifyEnv = new URL(window.location.href).searchParams.get('shopifyEnv');
		if(shopifyEnv) {
			return shopifyEnv;
		}

    const urlMap = {
      prod: ["https://vograce.com"],
      testing: ["https://xn-ooru7ap8r6la930dn7x8fucnc.myshopify.com/"],
      dev: [
        "https://xn-ooru7az5q7qa810dn7x8fucnce02b.myshopify.com/",
        "http://127.0.0.1",
        "http://localhost",
      ],
    };

   shopifyEnv = 'prod';
    Object.keys(urlMap).find(key => {
      const hasUrl = urlMap[key].some(url => window.location.href.startsWith(url));
      if (hasUrl) {
        shopifyEnv = key;

        return true;
      }

      return false;
    });

    return shopifyEnv;
  },

  /** 获取 基于当前环境的 api host */
  getApiHost() {
    const shopifyEnv = this.getShopifyEnv();
    const apiHostMap = {
      prod: "https://app.vograce.com/shopify-api",
      testing: "https://vograce-app-testing.baigedi.com/shopify-api",
      dev: "https://vograce-app-testing.baigedi.com/shopify-api",
      // dev: 'https://vograce-app-dev.baigedi.com/shopify-api',
    };
    return apiHostMap[shopifyEnv];
  },
  getShopDomainEnv() {
    const SHOP_DOMAIN = {
      prod: "vograce",
      testing: "vograce-test",
      dev: "vograce-test",
    };
    const shopifyEnv = this.getShopifyEnv();
    return SHOP_DOMAIN[shopifyEnv];
  },
  showMessage(message, type = "default") {
    const msgBox = $("#message-center");
    // 清空内容并更新
    msgBox
      .empty()
      .text(message)
      .removeClass("message-success message-error")
      .addClass(
        type !== "default" ? `message-${type} message-center` : "message-center"
      );
    // 判断是否为 H5 视口
    const isMobile = window.innerWidth <= 768;
    if (isMobile) {
      const height = msgBox.height();
      if (height > 30) {
        msgBox.css("width", "80%"); // 设置宽度为 80%
      }
    }
    // 淡入显示 → 延时3秒 → 淡出移除
    msgBox.fadeIn(300, function () {
      setTimeout(() => {
        msgBox.fadeOut(300);
      }, 2000);
    });
  },
  getTimeZone() {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  },
  fetchFactory({ url, method, data, header }) {
    const formData = new FormData(); // 创建FormData对象
    const baseUrl = this.getApiHost();
    header = header || {};
    let headerParams = {
      "customer-id": customer_id || localStorage.getItem("chat_token"),
      sign: customer_slat,
      timestamp: now_timestamp,
      "shop-domain": this.getShopDomainEnv(),
      "X-Timezone": this.getTimeZone(),
      ...header,
    };
    for (let key in data) {
      formData.append(key, data[key]); // 将文件添加到FormData中
    }
    if (this.getQueryString("share_shopify_customer_id")) {
      formData.append(
        "share_shopify_customer_id",
        this.getQueryString("share_shopify_customer_id")
      );
    }
    return new Promise((rej, rev) => {
      fetch(baseUrl + url, {
        // 你的上传URL
        method: method || "POST",
        mode: "cors",
        headers: {
          ...headerParams,
        },
        body: formData,
      })
        .then((response) => response.json()) // 如果服务器返回JSON
        .then((res) => {
          if (res.code == 200) {
            rej(res.data);
          } else {
            layer.closeAll();
            layer.msg(res.message);
            rev(res);
          }
        }) // 处理服务器返回的数据
        .catch((error) => {
          layer.closeAll();
          rev(error);
        }); // 处理错误
    });
  },
  getFactory({ url, method, data }) {
    const formData = new FormData(); // 创建FormData对象
    const baseUrl = this.getApiHost();
    let headerParams = {
      "customer-id": customer_id || localStorage.getItem("chat_token"),
      sign: customer_slat,
      timestamp: now_timestamp,
      "shop-domain": this.getShopDomainEnv(),
      "X-Timezone": this.getTimeZone(),
    };

    return new Promise((rej, rev) => {
      $.ajax({
        url: baseUrl + url,
        type: "GET",
        headers: {
          ...headerParams,
        },
        data: {
          ...data,
        },
        success: function (res) {
          if (res.code == 200) {
            rej(res.data);
          } else {
            layer.closeAll();
            layer.msg(res.message);
            rev(res);
          }
        },
      });
    });
  },
  getQueryString(name) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
    var r = window.location.search.substr(1).match(reg);
    if (r != null) {
      return unescape(r[2]);
    } else {
      return null;
    }
  },
  fallbackCopyTextToClipboard(text) {
    const textArea = document.createElement("textarea");
    textArea.value = text;
    document.body.appendChild(textArea);
    textArea.select();
    try {
      document.execCommand("copy");
    } catch (err) {
      console.error("复制失败:", err);
    }
    document.body.removeChild(textArea);
  },
  buttonLoadingshow(button, index) {
    let $btn = $vog(button);
    if (index) {
      $btn = $vog(button)[index];
    }
    $btn.addClass("is-loading").prop("disabled", true);
  },

  // 隐藏loading状态
  buttonLoadinghide(button) {
    const $btn = $vog(button);
    // 恢复原始内容
    $btn.removeClass("is-loading").prop("disabled", false);
  },
  showGlobalLoading() {
    const loader = document.getElementById("global-loading");
    if (loader) {
      loader.style.display = "flex";
    }
  },

  hideGlobalLoading() {
    const loader = document.getElementById("global-loading");
    if (loader) {
      loader.style.display = "none";
    }
  },
  /** 监听DOM ready */
  DOMready(callback) {
    if (document.readyState != "loading") callback();
    else document.addEventListener("DOMContentLoaded", callback);
  },
};

class JQMessageBox {
  constructor() {
    // 确保 DOM 结构存在
    if ($("#msgbox-overlay").length === 0) {
      const html = `
        <div id="msgbox-overlay" style="display:none; position:fixed; top:0; left:0; width:100%; height:100%; background:rgba(0,0,0,0.5); z-index:9999;"></div>
        <div id="msgbox-container" style="display:none; position:fixed; top:50%; left:50%; transform:translate(-50%, -50%); background:#fff; padding:20px;  z-index:10000; box-shadow:0 4px 12px rgba(0,0,0,0.1); width:400px; max-width:90%;">
          <h3 id="msgbox-title" style="margin-top:0; color:#333;"></h3>
          <p id="msgbox-message" style="color:#666; margin-bottom:20px;"></p>
          <div style="text-align:right;">
            <button id="msgbox-confirm-btn" style="padding: 5px 14px;font-size: 12px; background:#528ec1; color:#fff; border:none; ">Confirm</button>
            <button id="msgbox-cancel-btn" style="padding: 5px 14px;font-size: 12px; background:#f0f0f0; border:1px solid #ddd;  margin-right:10px;">Close</button>
          </div>
        </div>
      `;
      $("body").append(html);
    }

    this.overlay = $("#msgbox-overlay");
    this.container = $("#msgbox-container");
    this.titleEl = $("#msgbox-title");
    this.messageEl = $("#msgbox-message");
    this.confirmBtn = $("#msgbox-confirm-btn");
    this.cancelBtn = $("#msgbox-cancel-btn");

    this.resolvePromise = null;
    this.rejectPromise = null;

    this.initEvents();
  }

  initEvents() {
    const self = this;
    this.confirmBtn.on("click", function (e) {
      if (typeof self.resolvePromise === "function") {
        const resolveFn = self.resolvePromise;
        self.hide();
        resolveFn(); // 先调用再清理
        self.cleanup();
      }
    });

    this.cancelBtn.on("click", function (e) {
      if (typeof self.rejectPromise === "function") {
        const rejectFn = self.rejectPromise;
        self.hide();
        rejectFn(); // 先调用再清理
        self.cleanup();
      }
    });
    this.overlay.on("click", function () {
      if (typeof self.rejectPromise === "function") {
        const rejectFn = self.rejectPromise;
        self.hide();
        rejectFn();
        self.cleanup();
      }
    });
  }

  confirm(message, title = "info", options = {}) {
    // 清理之前的Promise
    this.cleanup();

    // 设置内容
    this.titleEl.text(title);
    this.messageEl.text(message);
    this.confirmBtn.text(options.confirmText || "Confirm");
    this.cancelBtn.text(options.cancelText || "Close");

    // 显示弹窗
    this.container.show();
    this.overlay.show();

    return new Promise((resolve, reject) => {
      // 保存resolve/reject方法
      this.resolvePromise = () => {
        resolve();
        this.cleanup();
      };

      this.rejectPromise = () => {
        reject();
        this.cleanup();
      };
    });
  }
  alert(message, title = "info", options = {}) {
    // 清理之前的Promise
    this.cleanup();

    // 显示弹窗
    this.titleEl.text(title);
    this.messageEl.text(message);
    this.confirmBtn.text(options.confirmText || "Close");
    this.cancelBtn.hide();

    this.container.show();
    this.overlay.show();
    return new Promise((resolve, reject) => {
      // 保存resolve/reject方法
      this.resolvePromise = () => {
        resolve();
        this.cleanup();
      };

      this.rejectPromise = () => {
        reject();
        this.cleanup();
      };
    });
  }
  // 新增清理方法
  cleanup() {
    this.resolvePromise = null;
    this.rejectPromise = null;
  }
  hide() {
    this.container.hide();
    this.overlay.hide();
    this.cleanup();
  }
}

VogUtils.DOMready(() => {
  try {
    VogUtils.JQMessageBox = new JQMessageBox();
    // 验证初始化
    if (!VogUtils.JQMessageBox || !VogUtils.JQMessageBox.confirm) {
      throw new Error("MessageBox初始化失败");
    }
    console.log("JQMessageBox initialized successfully");
  } catch (error) {
    console.error("JQMessageBox初始化错误:", error);
  }
});
